import { AppService } from "@/service/app.service";
import {
    GET_CREW_PER_MANNING_REPORT,
    GET_LAST_MEMO_VIEWED_REPORT,
    GET_CREW_LAST_MEMO_VIEWED_REPORT
} from "@/config/constants.config";

const state = {
    crewPerManningReport: [],
    lastMemoViewedReport: [],
};

const mutations = {
    SET_CREW_PER_MANNING_REPORT: (state, crewPerManningReport) => state.crewPerManningReport = crewPerManningReport,
    SET_LAST_MEMO_VIEWED_REPORT: (state, lastMemoViewedReport) => state.lastMemoViewedReport = lastMemoViewedReport,
};

const actions = {

    async getCrewPerManningReport({ commit }, params) {
        commit('SET_CREW_PER_MANNING_REPORT', []);
        let crewManningReport = await AppService.submitPostData(GET_CREW_PER_MANNING_REPORT, params);
        if(crewManningReport) commit('SET_CREW_PER_MANNING_REPORT', crewManningReport);
    },

    async getLastMemoViewedReport({ commit }, isCrew) {
        let url = isCrew ? GET_CREW_LAST_MEMO_VIEWED_REPORT: GET_LAST_MEMO_VIEWED_REPORT;
        commit('SET_LAST_MEMO_VIEWED_REPORT', []);
        let lastMemoViewedReport = await AppService.submitPostData(url, {});
        if(lastMemoViewedReport) commit('SET_LAST_MEMO_VIEWED_REPORT', lastMemoViewedReport);
    }

};

const getters = {
    crewPerManningReport: state => AppService.capitalizeProperties(state.crewPerManningReport),
    lastMemoViewedReport: state => AppService.capitalizeProperties(state.lastMemoViewedReport),
};

export default {state, mutations, actions, getters};